import { FC } from 'react';

import { Button, Stack } from '@mui/material';

import useDialog from 'store/dialog';
import useCurrentUser from 'store/currentUser';

import Wallet from './Wallet';
import UserProfile from './UserProfile';
import Notifications from './Notifications';
import useTranslates from 'utils/translate';
import useSettings, { IWebsiteConfigs } from 'store/settings';
import RefreshButton from 'components/common/Actions/RefreshButton';
import useRealBalance from 'store/realBalance';

const sx = {
  depositNowButton: {
    minWidth: 150,
  },
};

const UserSection: FC = () => {
  const { translate } = useTranslates();
    const [, realBalanceActions] = useRealBalance();
  const [, dialogActions] = useDialog();
  const [currentUser] = useCurrentUser();
  const [
    {
      data: { meta = {} as IWebsiteConfigs },
    },
  ] = useSettings();

  if (currentUser?.data?.id) {
    return (
      <Stack direction="row" gap={2} alignItems="center">
        <Wallet />
        {meta?.showBalanceUpdate && (<RefreshButton onClick={() => realBalanceActions.read()} fontSize={34} color="inherit" />)}
        <Notifications />
        <UserProfile user={currentUser?.data} />
      </Stack>
    );
  }

  return (
    <Stack direction="row" gap={2} alignItems="center">
      {meta.showDeposit && (
        <Button
          variant="contained"
          color="success"
          style={{
            color: meta.customColors?.deposit || 'success',
            backgroundColor: meta.customColors?.depositBg || 'primary.main',
          }}
          sx={sx.depositNowButton}
          onClick={() => dialogActions.set('signIn')}
          data-testid="deposit-now-btn"
        >
          {translate('deposit_now')}
        </Button>
      )}
      <Button
        variant="contained"
        style={{
          color: meta.customColors?.signIn || 'text.main',
          backgroundColor: meta.customColors?.signInBg || 'primary.main',
        }}
        onClick={() => dialogActions.set('signIn')}
        data-testid="sign-in-button"
      >
        {translate('sign_in')}
      </Button>
      {meta.showSignup && (
        <Button
          variant="contained"
          style={{
            color: meta.customColors?.signIn || 'text.main',
            backgroundColor: meta.customColors?.signInBg || 'primary.main',
          }}
          onClick={() => dialogActions.set('signUp')}
          data-testid="sign-up-button"
        >
          {translate('sign_up')}
        </Button>
      )}
    </Stack>
  );
};

export default UserSection;
